export type AppVariant = 'A' | 'B';

const normalizeAppVariant = (value: string | undefined): AppVariant => {
  const normalized = (value || 'A').trim().toUpperCase();
  return normalized === 'B' ? 'B' : 'A';
};

export const APP_VARIANT: AppVariant = normalizeAppVariant(process.env.REACT_APP_APP_VARIANT);
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
